import dynamic from 'next/dynamic'
import React from 'react'

import { AiSetupProvider } from '@/src/domains/ai/components/AiSetupProvider'

import GrowthBookAuth from '../lib/growthbook/components/GrowthBookAuth'

const MessagesProvider = dynamic(
  () => import('../contexts/messages-context/messages-context').then((file) => file.MessagesProvider),
  {
    ssr: false,
  },
)

const ProvidersAuthenticated: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <MessagesProvider>
      <GrowthBookAuth>
        <AiSetupProvider>{children}</AiSetupProvider>
      </GrowthBookAuth>
    </MessagesProvider>
  )
}

export default ProvidersAuthenticated
